module.exports = __webpack_public_path__ + "static/media/604.4fd2a804.webp";